enum MessageType {
  bankSlipCopy,
  checkoutError,
  checkoutSuccess,
  closePayment,
  emv3dsChallengeSuppression,
  emv3dsDisabled,
  emv3dsError,
  emv3dsFailure,
  emv3dsReady,
  emv3dsSuccess,
  emv3dsUnenrolled,
  emv3dsUnsupportedBrand,
  initData,
  pixCopy,
  ready,
  speiCopy,
  pagoEfectivoCopy,
  sizeChange,
}

export default MessageType
